export const deadLetterQueueConstants = {
  DEAD_LETTER_QUEUE_STATUS_ARR: {
    Abgelehnt: "Abgelehnt",
    Genehmigt: "Genehmigt",
  },
  GET_DEAD_LETTER_QUEUE_LIST: "GET_DEAD_LETTER_QUEUE_LIST",
  GET_DEAD_LETTER_QUEUE_XML_SUCCESS: "GET_DEAD_LETTER_QUEUE_XML_SUCCESS",
  GET_UNMATCHED_DEAD_LETTER_QUEUE_LIST: "GET_UNMATCHED_DEAD_LETTER_QUEUE_LIST",
  GET_UNMATCHED_DEAD_LETTER_QUEUE_XML_SUCCESS:
    "GET_UNMATCHED_DEAD_LETTER_QUEUE_XML_SUCCESS",
};
export const DLQ_TENANT_INFO_LABEL = "Dead Letter Queue Manager Mandant:";
export const MAPPED_DLQ = "Mapped";
export const UNMAPPED_DLQ = "Unmapped";
export const EMPTY_SELECTION_ERROR_MESSAGE =
  "Bitte wählen Sie mindestens einen Eintrag aus, um die gewünschte Funktionalität zu nutzen.";

export const MAPPED_DLQ_DOWNLOAD_LINK = "DLQ_MAPPED";
export const UNMAPPED_DLQ_DOWNLOAD_LINK = "DLQ_UNMAPPED";
